export default __webpack_public_path__ + "static/media/dragon.4ba7da53.svg";